"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import _ from "lodash";
import { Debounce } from "vue-debounce-decorator";
let CopyRuleDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.activeName = "first";
    this.selectDatas = [];
    this.shopId = null;
    this.selectLock = false;
    this.searchStr = "";
    this.rows = [];
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v7/users")
    );
    // dialog: any = new UiDialogController();
    this.memberData = null;
  }
  created() {
    this.gridController.pagePosition = "dialog";
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.size = true;
    this.gridController.query.filter = `userStatus=='0';`;
  }
  open(data) {
    this.memberData = data;
    this.gridController.query.filter = `userStatus=='0';guid!='${data.id}'`;
    this.gridController.search();
    this._distributionDialog.open();
  }
  saved(data) {
    return __async(this, null, function* () {
      try {
        const ids = _.map(data, "id");
        yield API.post(`api://base.auth/api/v1/users/${this.memberData.id}/copy_vd_shop_auth`, {
          "userGuids": ids
        });
        this.$message.success(this.$t("copy_role_dialog.copy_success"));
        this._distributionDialog.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  selectable(row, index) {
    return true;
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      let unSelectData = _.differenceWith(
        this.gridController.result.datas,
        items,
        _.isEqual
      );
      for (const item of items) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.del(_item);
      }
    }
  }
  changed(data) {
    let rows = _.differenceWith(
      this.selectDatas,
      data,
      (selectData, data2) => selectData.guid == data2.id
    );
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    let selectDatas = this._distributionDialog.getAll();
    let rows = _.intersectionWith(
      this.gridController.result.datas,
      selectDatas,
      (selectData, data) => selectData.guid == data.id
    );
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  searchByName(searchStr) {
    return __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        this.gridController.query.filter = `userStatus=='0';guid!='${this.memberData.id}';name=='%${searchStr}%',account=='%${searchStr}%'`;
      }
      if (searchStr === null || searchStr === "") {
        this.gridController.query.filter = `userStatus=='0';guid!='${this.memberData.id}'`;
      }
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
  closeDialog() {
    this.searchStr = "";
    this.gridController.query.filter = `userStatus=='0'`;
  }
  //   async open(row: any) {
  //     console.log(row);
  //     this.memberData = row;
  //     this.dialog.visible = true;
  //   }
  //   closeDialog() {
  //     this.dialog.visible = false;
  //   }
};
__decorateClass([
  Ref("distributionDialog")
], CopyRuleDialog.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], CopyRuleDialog.prototype, "_multipleTable", 2);
__decorateClass([
  Debounce(600)
], CopyRuleDialog.prototype, "searchByName", 1);
CopyRuleDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      DistributionDialog,
      UiGrid
    }
  })
], CopyRuleDialog);
export {
  CopyRuleDialog as default
};
